module.exports = __webpack_public_path__ + "assets/img/chef-9.e322d003.jpg";